import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NoOktaWrapper, NoOktaModelWrapper } from '../Live.style';
import FieldVisionAuthEntry, { TYPES } from '../../FieldVision/components/auth/index';
import { ModalTypes } from '../../AtBat/atbat.style';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import Overlay from '../../Overlay/Overlay';
import { useAccessToken } from '@gameday/utils/hooks/usePermissionToTrack';
import { FieldVisionModalContent, FieldVisionVerticalExploreModalContent, FieldVisionExploreModalContent } from '../..//Overlay/overlay.style';
import MlbNativeWrapper from '@gameday/utils/MlbNativeWrapper';

const NoOktaOrFV = ({
    isAuthOpen,
    onAuthClose,
    componentType,
    setComponentType,
    setFirstRunUser,
    onClose,
    isSingleCol,
    lockView = false
}) => {
    const translate = useTranslate();
    const noOkta = translate('fieldvision_login_message', 'To view Gameday 3D login via the MLB App. To do so, tap on the account icon in the upper left of the Home screen then tap Log In or Create MLB Account');
    const accessToken = useAccessToken();
    const [overlayProps, setOverlayProps] = useState({ type: null, wrapper: null });

    useEffect(() => {
        if (!window?.mlbOkta) {
            if (!accessToken) {
                MlbNativeWrapper.then((results) => {
                    const { login } = results;
                    if (typeof login === 'undefined') {
                        // show no okta overlay if native login is not available
                        setOverlayProps({
                            type: ModalTypes.NO_OKTA,
                            wrapper: NoOktaModelWrapper
                        });
                    }
                });
            } else {
                if (componentType !== TYPES.LOGIN) {
                    setOverlayProps({
                        type: !isSingleCol ? ModalTypes.FIELDVISION : ModalTypes.FIELDVISION_VERTICAL,
                        wrapper: !isSingleCol ? FieldVisionModalContent : null
                    });
                }
            }
        } else {
            if (componentType === TYPES.EXPLORE) {
                setOverlayProps({
                    type: !isSingleCol ? ModalTypes.FIELDVISION : ModalTypes.FIELDVISION_VERTICAL,
                    wrapper: !isSingleCol ? FieldVisionExploreModalContent : FieldVisionVerticalExploreModalContent
                });
            } else {
                setOverlayProps({
                    type: !isSingleCol ? ModalTypes.FIELDVISION : ModalTypes.FIELDVISION_VERTICAL,
                    wrapper: !isSingleCol ? FieldVisionModalContent : null
                });
            }
        }
    }, [window?.GamedayMlbNativeWrapper, isSingleCol, ModalTypes, accessToken, MlbNativeWrapper, componentType]);
    const { type, wrapper } = overlayProps;
    if (!type) {
        return null;
    }

    return (
        <Overlay
            isCentered={true}
            isOpen={isAuthOpen}
            onClose={onClose}
            type={type}
            ContentComponent={wrapper}
        >
            {type === ModalTypes.NO_OKTA
                ? <NoOktaWrapper>{noOkta}</NoOktaWrapper>
                : (
                    <FieldVisionAuthEntry
                        lockView={lockView}
                        componentType={componentType}
                        setComponentType={setComponentType}
                        setFirstRunUser={setFirstRunUser}
                        onClose={onAuthClose}
                        isSingleCol={isSingleCol}
                    />
                )
            }
        </Overlay>
    );
};

NoOktaOrFV.propTypes = {
    isAuthOpen: PropTypes.bool,
    onAuthClose: PropTypes.func,
    componentType: PropTypes.string,
    setComponentType: PropTypes.func,
    onClose: PropTypes.func,
    setFirstRunUser: PropTypes.func,
    isSingleCol: PropTypes.bool,
    lockView: PropTypes.bool
};

export default NoOktaOrFV;
